import CustomModuleCards from '../../../components/CustomModuleCard/CustomModuleCards';
import { ViewModule } from '../../../types/api/payload/module';

export default function AccountantMarketPlace() {
  return <CustomModuleCards view={ViewModule.accountantMarketPlace} />;
}
